/**
 * @generated SignedSource<<4a65c37d00c9a2394d346ed3140ab132>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AsanaIntegrationPerItemModalWorkspaceQuery$variables = {};
export type AsanaIntegrationPerItemModalWorkspaceQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly asana: {
        readonly isConnected: boolean;
        readonly workspaces: ReadonlyArray<{
          readonly externalId: string;
          readonly id: string;
          readonly name: string;
        }> | null;
      } | null;
    };
    readonly " $fragmentSpreads": FragmentRefs<"AsanaIntegrationAddProjectContent_viewer">;
  };
};
export type AsanaIntegrationPerItemModalWorkspaceQuery = {
  response: AsanaIntegrationPerItemModalWorkspaceQuery$data;
  variables: AsanaIntegrationPerItemModalWorkspaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "AsanaWorkspaceNode",
  "kind": "LinkedField",
  "name": "workspaces",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AsanaIntegrationPerItemModalWorkspaceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AsanaIntegrationAddProjectContent_viewer"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaUserNode",
                "kind": "LinkedField",
                "name": "asana",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AsanaIntegrationPerItemModalWorkspaceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaUserNode",
                "kind": "LinkedField",
                "name": "asana",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v1/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac61a69b9b145e649cd07b82c1f21043",
    "id": null,
    "metadata": {},
    "name": "AsanaIntegrationPerItemModalWorkspaceQuery",
    "operationKind": "query",
    "text": "query AsanaIntegrationPerItemModalWorkspaceQuery {\n  viewer {\n    ...AsanaIntegrationAddProjectContent_viewer\n    integrations {\n      asana {\n        isConnected\n        workspaces {\n          id\n          externalId\n          name\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment AsanaIntegrationAddProjectContent_viewer on Viewer {\n  integrations {\n    asana {\n      workspaces {\n        id\n        externalId\n        name\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "120de88e1ac3090d165508e279c02cc2";

export default node;
